module.exports = __webpack_public_path__ + "img/summit-icon.ce5cf024.png";